// ShareModal.jsx
"use client";

import React from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@heroui/modal";

import { Button } from "@heroui/button";
import ShareComponent from "@/src/components/AnalystsIdeas/ShareComponent"; // Import your ShareComponent
import { Share } from "lucide-react";

export default function ShareModal({ url, title }) {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return (
    <>
      <Button
        size="sm"
        startContent={<Share size={17} strokeWidth={1.4} />}
        onPress={onOpen}
        color="primary"
      >
        Share
      </Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          <ModalHeader>Share this Content</ModalHeader>
          <ModalBody>
            <ShareComponent url={url} title={title} />
          </ModalBody>
          <ModalFooter>
            <Button
              size="sm"
              auto
              flat
              color="primary"
              onPress={() => onOpenChange(false)}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
